import axios from "axios";
import router from "../router"
import {AESDecrypt,AESEncrypt} from './Aes'

// 加密开关：true = 启用加密，false = 不加密（默认）
const ENABLE_ENCRYPT = false

const http = axios.create({
  //请求头
    // headers: {"Content-Type": "application/json", "Access-Control-Allow-Origin": "*"},
  baseURL: process.env.BASE_URL,
    timeout: 10000,
    // withCredentials: false, // 跨域请求是否需要携带 cookie
})

// 添加请求拦截器
http.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  if (config.data.cmd !== "login") {
    config.headers["token"] = localStorage.getItem('token')
    config.data["params"]["proxy_id"] = parseInt(localStorage.getItem('proxy_id'), 10)
    config.data["params"]["username"] = localStorage.getItem('username')
    var userInfo = JSON.parse(localStorage.getItem('userInfo'))
    if (userInfo.is_sub){
      config.data["params"]["is_sub"] = userInfo.is_sub
      config.data["params"]["sub_proxy_id"] = parseInt(userInfo.sub_proxy_id, 10)
    }
  }
  if (ENABLE_ENCRYPT) {
    var param = JSON.stringify(config.data["params"])
    config.data["params"] = AESEncrypt(param)
  }
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});

// 添加响应拦截器
http.interceptors.response.use(function (response) {
  // 对响应数据做点什么
  if(response.data.errcode == -2){
    // alert("Please log in again.")
    localStorage.removeItem('token')
    localStorage.removeItem('userInfo')
    localStorage.removeItem('username')
    localStorage.removeItem('level')
    localStorage.removeItem('proxy_id')
    router.push({ name: 'login'  })
    return
  }else if (response.data.errcode == -5){
    alert("Account disabled")
    localStorage.removeItem('token')
    localStorage.removeItem('userInfo')
    localStorage.removeItem('username')
    localStorage.removeItem('level')
    localStorage.removeItem('proxy_id')
    router.push({ name: 'login'  })
    return
  }
  return response;
}, function (error) {
  if (error.response) {
    const status = error.response.status
    if (status === 403) {
      alert("Access denied (403)")
    } else if (status === 404) {
      alert("Resource not found (404)")
    } else if (error.message.includes('timeout')) {
      alert("Request timeout")
    } else {
      alert("Request error: " + status)
    }
  } else if (error.message.includes('timeout')) {
    alert("Request timeout")
  } else {
    alert("Network error")
  }
  return Promise.reject(error);
});

export default http



// WEBPACK FOOTER //
// ./src/utils/request.js